import React, { useEffect, useContext } from 'react';
import { pickBy, isEmpty, compact } from 'lodash/fp';
import { routes } from 'constants/config';
import { Icon } from 'ui';
import { FilterContext } from 'components/shared/FilterContext/index';
import FilterByGroups from './Groups';
import FilterByDate from './DateRange';
import SelectedFilters from './SelectedFilters';
import { HasSelectedFilters } from './HasFilters';

const compactObject = pickBy(value => !isEmpty(value));

function updateUrl(params) {
  const query = $.param(params);
  const url = compact([routes.INSIGHTS.INDEX, decodeURI(query)]).join('?');
  window.history.replaceState(null, '', url);
}

const Filters = ({ groups, manageAllUsers }) => {
  const { params } = useContext(FilterContext);
  useEffect(() => updateUrl(params), [params]);
  return (
    <div className="mb-16">
      <div className="mb-16 ff-ss d-f ai-c">
        <FilterByGroups groups={groups} />
        <FilterByDate />
        <HasSelectedFilters>
          <div className="Animated Animated--fadeIn ml-16 d-f ai-c mt-0 p-2-8 bg-teal c-white bdrs-small fw-b fz-12 f-smooth">
            {t('insights.filters.hidden_modules')}
            <Icon
              name="info"
              data-toggle="tooltip"
              className="ml-4"
              svgClassName="mt-0"
              data-original-title={t(
                'insights.filters.hidden_modules_description',
              )}
            />
          </div>
        </HasSelectedFilters>
        <div className="ml-16 c-gray-dark">
          {t('insights.what_data.title')}
          <Icon
            name="info"
            data-toggle="tooltip"
            className="ml-4"
            svgClassName="mt-0"
            data-original-title={
              manageAllUsers
                ? t('insights.what_data.tooltip.manage_all_users')
                : t('insights.what_data.tooltip.managed_users')
            }
          />
        </div>
      </div>
      <SelectedFilters />
    </div>
  );
};

Filters.toParams = filters => {
  const { date, groups } = filters;
  return compactObject({
    start_date: date.start,
    end_date: date.end,
    group_ids: groups,
  });
};

export default Filters;
